import React from 'react';
import type { OrgLaunchSettings } from '@bb/automaton';
import getOrgLaunchSetting from 'api/OrgController/getOrgLaunchSetting';
import AuthContext from '../AuthContext';
import LayoutContext from '../LayoutContext';
import OnboardingPreLaunchModalContext from './OnboardingPreLaunchModalContext';

export type SetupBrokerageModalContextType = {
  visible: boolean;
  openModal: () => void;
  closeModal: (shouldOpenPreLaunchModal?: boolean) => void;
  launchSetting: OrgLaunchSettings | undefined;
};

const SetupBrokerageWizardModalContext =
  React.createContext<SetupBrokerageModalContextType>({
    visible: false,
    openModal: () => null,
    closeModal: () => null,
    launchSetting: undefined,
  });

export const SetupBrokerageWizardModalContextProvider: React.FC = ({
  children,
}) => {
  const { auth } = React.useContext(AuthContext);

  const { openModal: openPreLaunchModal } = React.useContext(
    OnboardingPreLaunchModalContext,
  );

  const [visible, setVisible] = React.useState(false);

  const [launchSetting, setLaunchSetting] = React.useState<OrgLaunchSettings>();

  React.useEffect(() => {
    const fetchLaunchSetting = async () => {
      const data = await getOrgLaunchSetting();
      if (data) setLaunchSetting(data);
    };

    if (auth && auth.org.type === 'brokerage' && auth.org.onboardingPortalId) {
      fetchLaunchSetting();
    }
  }, [auth]);

  const { setChatVisibility } = React.useContext(LayoutContext);

  const openModal: SetupBrokerageModalContextType['openModal'] = () => {
    setChatVisibility(false);
    setVisible(true);
  };

  const closeModal: SetupBrokerageModalContextType['closeModal'] =
    shouldOpenPreLaunchModal => {
      setChatVisibility(true);
      setVisible(false);
      if (shouldOpenPreLaunchModal) openPreLaunchModal();
    };

  return (
    <SetupBrokerageWizardModalContext.Provider
      value={{ visible, openModal, closeModal, launchSetting }}
    >
      {children}
    </SetupBrokerageWizardModalContext.Provider>
  );
};

export default SetupBrokerageWizardModalContext;
